export default __webpack_public_path__ + "static/media/circleQuestion.b22f93b0.svg";